import React__default from 'react';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { PortalTargetProvider } from './b06a6d7d3063091eeee24790f7ab6da8c2d138992e1cbad0f6fb0cbc953133e9.cfe-internal.js';
import { TranslationProvider } from '../../utils/Translation/c7268ad05315aa6581985a8e9d9c1590614c37cca492b9c25bcac99eb73265da.cfe-internal.js';

var UIProvider = function UIProvider(_ref) {
  var children = _ref.children,
    portalTarget = _ref.portalTarget,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config;
  return /*#__PURE__*/React__default.createElement(TranslationProvider, {
    localizedText: config === null || config === void 0 ? void 0 : config.localizedText
  }, /*#__PURE__*/React__default.createElement(PortalTargetProvider, {
    target: portalTarget !== null && portalTarget !== void 0 ? portalTarget : null
  }, children));
};

export { UIProvider };
